const ESTADO_STYLES = {
  PENDIENTE: 'bg-amber-50 text-amber-700',
  APROBADA: 'bg-green-50 text-green-700',
  RECHAZADA: 'bg-red-50 text-red-700',
  ACTIVA: 'bg-green-50 text-green-700',
  ANULADA: 'bg-gray-100 text-gray-600',
  // Estados de sincronización LOCAL de una aplicación creada offline — no
  // son estado de servidor (ACTIVA/ANULADA), por eso llevan estilo y texto
  // deliberadamente distintos.
  'PENDIENTE DE SINCRONIZAR': 'bg-amber-50 text-amber-700',
  SINCRONIZANDO: 'bg-blue-50 text-blue-700',
  'ERROR AL SINCRONIZAR': 'bg-red-50 text-red-700',
};

function StatusBadge({ estado }) {
  return (
    <span
      className={`inline-flex shrink-0 rounded-full px-3 py-1 text-xs font-medium ${
        ESTADO_STYLES[estado] || 'bg-gray-100 text-gray-600'
      }`}
    >
      {estado}
    </span>
  );
}

export default StatusBadge;
